export default function Check (props) {

    return (
        <svg stroke={props.stroke} className={props.className} style={props.style} xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 17 14">
            <path d="M 0 3 L 3 6 L 9 0" strokeLinecap="square" strokeLinejoin="round" fill="transparent"/>
        </svg>
    )

}